<template>
  <div class="card mb-5 bg-light border-0">
    <div class="card-body py-5">
      <p class="text-center text-muted mb-0">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-arrow-left-circle opacity-5 mb-1" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
        </svg>
        <br />
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script charset="utf-8">
export default {
  name: "Error",
  props: ["message"],
};
</script>
